import React from 'react'

interface ArticlesSectionHeaderProps {
  title?: string
  description?: string
}

export const ArticlesSectionHeader = ({
  title,
  description,
}: ArticlesSectionHeaderProps) => {
  if (!title && !description) return null

  return (
    <header className='mb-4 flex flex-col sm:mb-8 xl:mb-3'>
      {title && (
        <h2 className='font-body text-lg font-medium tracking-normal sm:font-display sm:text-2xl'>
          {title}
        </h2>
      )}

      {description && (
        <p className='font-body text-sm font-normal text-cool-600'>
          {description}
        </p>
      )}
    </header>
  )
}
